module.exports = function () {
    const header = document.querySelector(".header");
    if ( !header ) return;
    
    let isOpen = false;
    const hamBtn = header.querySelector(".header__ham");
    let lastScrollY = window.scrollY;
    let isMouseOverHeader = false;
    
    header.addEventListener("click", e => {
        const parent = e.target.parentNode;
        
        if ( parent.classList.contains("menu-item-has-children") ) {
            e.preventDefault();
            const subMenu = parent?.querySelector(".sub-menu");
            
            if ( window.innerWidth < 1280 ) {
                if ( parent.classList.contains("active") ) {
                    parent.classList.remove("active");
                    subMenu.style.maxHeight = null;
                }
                else {
                    parent.classList.add("active");
                    subMenu.style.maxHeight = subMenu.scrollHeight + "px";
                }
            }
        }
    })
    
    hamBtn.addEventListener("click", () => {
        if ( isOpen ) closeMenu();
        else openMenu();
    })
    
    function openMenu() {
        isOpen = true;
        document.body.classList.add("overflow-hidden");
        header.classList.add("open");
        
        document.addEventListener("click", closeOutSide);
    }
    
    function closeMenu() {
        isOpen = false;
        document.body.classList.remove("overflow-hidden");
        header.classList.remove("open");

        document.removeEventListener("click", closeOutSide);
        closeAllSubMenu();
    }
    
    function closeOutSide(e) {
        if ( !header.contains(e.target) ) closeMenu(); 
    }
    
    function closeAllSubMenu() {
        header.querySelectorAll(".menu-item-has-children")
            .forEach(item => {
                item.classList.remove("active");
                item.querySelector(".sub-menu").style.maxHeight = null;
            });
    }
    
    header.addEventListener("mouseover", () => {
        isMouseOverHeader = true;
    })
    
    header.addEventListener("mouseout", () => {
        isMouseOverHeader = false;
        handleScroll();
    })

    document.addEventListener("scroll", handleScroll);
    handleScroll();
    
    
    window.addEventListener("resize", () => {
        if ( window.innerWidth >= 1280 ) {
            closeAllSubMenu();
        }
        else {
            const subMenu = header.querySelector(".menu-item-has-children.active .sub-menu");
            if ( subMenu ) subMenu.style.maxHeight = subMenu.scrollHeight + "px";
        }
    })

    function handleScroll() {
        if ( (window.scrollY > lastScrollY + 50) && !isMouseOverHeader ) {
            header.classList.add("hide");
            lastScrollY = window.scrollY;
        }
        else if ( window.scrollY < lastScrollY ) {
            header.classList.remove("hide");
            lastScrollY = window.scrollY;
        }

        if ( window.scrollY > 25 ) {
            header.classList.add("scroll");
        }
        else {
            header.classList.remove("hide");
            header.classList.remove("scroll");
        }
    }
}